export const ACCEPT_COOKIES = 'ACCEPT_COOKIES';
export const acceptCookies = () => ({ type: ACCEPT_COOKIES });
